import { graphql } from 'react-apollo'
import { groupBy, keys } from 'ramda'
import { Layout, Table } from 'antd'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'
import React from 'react'

import checkOutItemsQuery from '../graphql/queries/checkOutItems'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'

const { Content } = Layout

const CheckOutItems = (props) => {
  const { items: { loading, items = [] } } = props
  const filterName = keys(groupBy(item => item.product.name, items)).map(item => ({ text: item, value: item }))
  const filterSize = keys(groupBy(item => item.product.size, items)).map(item => ({ text: item, value: item }))
  const filterColor = keys(groupBy(item => item.product.color, items)).map(item => ({ text: item, value: item }))
  const columns = [
    {
      title: 'Item ID',
      dataIndex: 'itemId',
      key: 'itemId',
      width: 150,
    },
    {
      title: 'Name',
      dataIndex: 'product.name',
      key: 'name',
      filters: filterName,
      onFilter: (value, record) => record.product.name === value,
    },
    {
      title: 'Size',
      dataIndex: 'product.size',
      key: 'size',
      filters: filterSize,
      onFilter: (value, record) => record.product.size === value,
    },
    {
      title: 'Color',
      dataIndex: 'product.color',
      key: 'color',
      filters: filterColor,
      onFilter: (value, record) => record.product.color === value,
    },
    {
      title: 'Check-out',
      children: [
        {
          title: 'By',
          dataIndex: 'checkOutBy.name',
          key: 'checkOutBy.name',
        },
        {
          title: 'Timestamp',
          key: 'checkOutAt',
          width: 200,
          render: record => moment(record.checkOutAt).tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:SS'),
        },
      ],
    },
  ]
  return (
    <Layout>
      <Navbar selected="product:4" />
      <Content style={{ padding: '0 20px' }}>
        <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
          <h2>Check-out items</h2>
          <Table
            dataSource={items}
            columns={columns}
            rowKey="_id"
            pagination={{ pageSize: 50 }}
            size="middle"
            loading={loading}
            bordered
          />
        </div>
      </Content>
      <Footer />
    </Layout>
  )
}
CheckOutItems.propTypes = {
  items: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool,
    items: PropTypes.array,
  }).isRequired,
}
CheckOutItems.defaultProps = {}

export default graphql(checkOutItemsQuery, { name: 'items' })(CheckOutItems)



// WEBPACK FOOTER //
// ./src/pages/CheckOutItems.js